import { createLabelValueText } from '../services/pdfHelpers';
import { ReportScope } from '../interfaces/workflow.interface';

const isOwnedByCompany = (ca: any, company: any): boolean =>
  ca.application.company &&
  ((typeof ca.application.company === 'number' && ca.application.company === company.id) ||
    (typeof ca.application.company !== 'number' && ca.application.company?.id === company.id));

export const addOverviewItems = (params: {
  output: any;
  application?: any;
  reportScope?: ReportScope;
  employeeCount?: any;
  site?: any;
  company?: any;
}): any => {
  const {
    output,
    application,
    reportScope,
    employeeCount,
    site,
    company,
  } = params;
  const stack = output.table.body[0][0].stack;

  // Related facilities
  if (application) {
    const relatedSites = reportScope ? reportScope.sites : application.sites;
    if (relatedSites?.length) {
      stack.push(createLabelValueText('Related Facilities', relatedSites.map((csite: any) => csite.name).join(', ')));
    }
  }

  // Services
  if (reportScope) {
    if (reportScope.services?.length) {
      stack.push(createLabelValueText('Services', reportScope.services.map((service: any) => service.name).join(', ')));
    }
  } else {
    if (site?.services?.length) {
      stack.push(createLabelValueText('Services', site.services.map((service: any) => service.name).join(', ')));
    }
    if (application?.services?.length) {
      stack.push(createLabelValueText('Services', application.services.map((service: any) => service.name).join(', ')));
    }
  }

  if (employeeCount?.text) {
    stack.push(createLabelValueText('Number of Employees', employeeCount.text));
  }

  // Applications - same reportScope-first, live-data-fallback approach
  if (reportScope) {
    if (site && reportScope.ownedApplications?.length) {
      stack.push(createLabelValueText('Owned Applications', reportScope.ownedApplications.map((app: any) => app.name).join(', ')));
    }
  } else if (site && company) {
    const ownedApps = company.companyApplications?.filter((ca: any) => isOwnedByCompany(ca, company));
    if (ownedApps?.length) {
      stack.push(createLabelValueText('Owned Applications', ownedApps.map((ca: any) => ca.application.name).join(', ')));
    }
  }

  if (application) {
    stack.push(createLabelValueText('Owned Application', application.application.name));
  }

  if (reportScope) {
    if (site && reportScope.thirdPartyApplications?.length) {
      stack.push(createLabelValueText('3rd Party Licensed Applications', reportScope.thirdPartyApplications.map((app: any) => app.name).join(', ')));
    }
  } else if (site && company) {
    const thirdPartyApps = company.companyApplications?.filter((ca: any) => !isOwnedByCompany(ca, company));
    if (thirdPartyApps?.length) {
      stack.push(createLabelValueText('3rd Party Licensed Applications', thirdPartyApps.map((ca: any) => ca.application.name).join(', ')));
    }
  }

  return output;
};
